
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const RemovalsPage = lazy(() => import('../pages/removals/page'));
const LandscapingPage = lazy(() => import('../pages/landscaping/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/removals',
    element: <RemovalsPage />,
  },
  {
    path: '/landscaping-services',
    element: <LandscapingPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
